import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { SUSPICIOUS_LOGIN_ACTION_TYPE } from "./suspicious-login.action";
import { SuspiciousLoginState } from "./suspicious-login.model";

const INITIAL_STATE: SuspiciousLoginState = {
	isPinSent: false,
};

export function suspiciousLoginReducer(state = INITIAL_STATE, action: ActionWithPayload): SuspiciousLoginState {
	switch (action.type) {
		case SUSPICIOUS_LOGIN_ACTION_TYPE.setCommunicationChannels: {
			return updateState(state, {
				challengeDetails: action.payload,
			});
		}
		case SUSPICIOUS_LOGIN_ACTION_TYPE.requestPinSuccess: {
			return updateState(state, {
				isPinSent: true,
			});
		}
		case SUSPICIOUS_LOGIN_ACTION_TYPE.verifyPin:
		case SUSPICIOUS_LOGIN_ACTION_TYPE.resetPin: {
			return updateState(state, {
				isPinSent: false,
			});
		}
		case SUSPICIOUS_LOGIN_ACTION_TYPE.clearCommunicationChannels: {
			return updateState(state, {
				challengeDetails: undefined,
			});
		}
		default: {
			return state;
		}
	}
}
